import type { VideoPreview } from "@brookbush/types";

import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";

const VideosCard = ({ slug, title, thumbnailUrl }: VideoPreview) => {
	return (
		<Link
			href={`/videos/${slug}`}
			className="group relative mx-auto flex aspect-[8/3] w-full cursor-pointer flex-col overflow-hidden rounded-2xl border transition-all duration-300 hover:shadow-slate-300 sm:aspect-[6/3] sm:max-w-full xl:hover:scale-105 dark:shadow-slate-900 dark:hover:shadow-black/70"
		>
			<div className="relative h-full w-full shrink-0">
				<Image
					quality={50}
					src={thumbnailUrl || "images/placeholder.png"}
					fill
					unoptimized
					placeholder="empty"
					className="object-cover"
					alt="picture"
				/>
			</div>

			<div className="absolute top-0 left-0 flex h-full w-full flex-col items-start justify-end gap-2.5 bg-gradient-to-t from-black/90 to-transparent px-3.5 py-2.5">
				<h3 className={clsx(`line-clamp-2 font-semibold text-lg text-white`)}>
					{title}
				</h3>
			</div>
		</Link>
	);
};

export default VideosCard;
